import React from "react";
import "./patientMeasurement.scss";
import "../../steps/forms.scss";
import FormTitle from "../../components/formTitle/FormTitle";
import MuiRadio from "../../components/radio/MuiRadio";
import RangeSlider from "../../components/range/RangeSlider";
import InputTextField from "../../components/textField/InputTextField";
import MuiDatePicker from "../../components/datePicker/MuiDatePicker";
import FieldState from "../../common/FieldState";
import OrderFormStep from "../../common/OrderFormStep";
import apiClient from "../../common/apiClient";
import Config from "../../common/Config";
import Button from "../../components/button/Button";
import SecondaryButton from "../../components/button/SecondaryButton";
import { Form } from "react-bootstrap";
import ttDefBodypart from "../../images/ttDefBodypart.png";
import { CreateNotification } from "../../components/notification/Notification";
import SaveAsDraft from "../../components/modal/SaveAsDraft";
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";

class TTOneMeasure extends OrderFormStep {
  constructor(props) {
    super(props);

    this.otherPRS = 26;
    this.laminatingSleeve = 141;

    this.uomMetric = 67;
    this.conversionFactor = 25.4;

    this.shortenId = 29;
    this.extendId = 30;

    this.nextCartQueueIndex=0;
    this.displayedCartIndex=0;

    this.state = {
      socketFinishes: [],
      mountingPlates: [],
      prostheticHeightUOMs: [],
      prostheticHeights: [],
      oneSystemOptions: [],
      UOMs: [],
      estimatedShipDate: null,
      isSubmit: false,
      formState: {
        socketFinish: new FieldState(false),
        otherPRS: new FieldState(false),
        fredsLegsDesignName: new FieldState(false),
        mountingPlate: new FieldState(true),
        prostheticHeightUOM: new FieldState(false, this.uomMetric),
        prostheticHeight: new FieldState(true),
        oneSystem: new FieldState(true),
        pumpSerial: new FieldState(false),
        UOM: new FieldState(true),
        amount: new FieldState(false, 0),
        itemsSentIn: new FieldState(true),
        notes: new FieldState(false),
        MPTToFloor: new FieldState(false),
        CalfToFloor: new FieldState(false),
        CalfCirc: new FieldState(false),
        AnkleCirc: new FieldState(false),
      },
    };
    this.handleAmountChange = this.handleAmountChange.bind(this);
    this.getNextCartQueueIndex = this.getNextCartQueueIndex.bind(this);
    this.shouldDisplayCart = this.shouldDisplayCart.bind(this);
  }

  getNextCartQueueIndex() {
    return this.nextCartQueueIndex++;
  }

  shouldDisplayCart(index) {
    if(index >= this.displayedCartIndex) {
      this.displayedCartIndex = index;
      return true;
    }

    return false;
  }

  loadCart() {
    let cart = [];

    let addToCart = (options, selectedId, sourceId) => {
      let item = options.filter(x => x.id===selectedId)[0];
      if(item && item.partNumbers && item.partNumbers.length > 0) {
        item.partNumbers.forEach(part => {
          cart.push({
            name: item.displayName,
            partNumber: part,
            quantity: 1,
            price: -1,
            sourceId: sourceId
          });
        });
      } else {
        cart.push({
            name: null,
            partNumber: null,
            quantity: 0,
            price: 0,
            sourceId: sourceId
          });
      }
    }

    addToCart(this.state.oneSystemOptions, this.state.formState.oneSystem.value, "oneSystem");
    addToCart(this.state.mountingPlates, this.state.formState.mountingPlate.value, "mountingPlate");
    addToCart(this.state.socketFinishes, this.state.formState.socketFinish.value, "socketFinish");

    
    let config = {};
    config.params = {
      cart: cart.map(x => x.partNumber)
    }

    const index = this.getNextCartQueueIndex();

    return this.loadShipDate()
      .then(r1 => {
        return apiClient.get("price/" + this.props.formTypeId
        ).then(response => {
          let data = response.data
  
          cart = cart.map(c => {
            return {
              name: c.name,
              partNumber: c.partNumber,
              quantity: c.quantity,
              price: data.filter(x => x.partNumber === c.partNumber)[0]?.price,
              sourceId: c.sourceId
            }
          });

          cart = cart.concat(data.filter(d => d.sourceId !== null).map(d => {
            return {
              name: d.name,
              partNumber: d.partNumber,
              quantity: d.quantity,
              price: d.price,
              sourceId: d.sourceId
            }
          }));
          
          if(this.shouldDisplayCart(index)) {
            this.props.setTempCart(cart);
          }
        }).catch(error =>{
          console.log(error)
        })
      });
  }

  componentDidMount() {
    this.loadData();
    this.loadMeasureData();
  }

  // onRadioChange(e) {
  //   super.onRadioChange(e);

  //   let formState = this.state.formState;
  //   formState.otherPRS.isRequired = this.isOtherPRSSelected();
  //   formState.fredsLegsDesignName.isRequired =
  //     this.isLaminatingSleeveSelected();
  //   this.setState({ formState: formState, hasDataChanged: true });
  // }

  async loadShipDate() {
    try {
      let estimatedShipDate = (
        await apiClient.get("shipDate/" + this.props.formTypeId
        )
      ).data;

      this.setState({
        estimatedShipDate: estimatedShipDate,
      });
    } catch (error) {
      //   this.props.handleError(new LoadFailureResult());
    }
    this.setState({ isLoaded: true });
  }

  async loadData() {
    try {
      this.setState({
        socketFinishes: (
          await apiClient.get("fieldOptions/" + this.props.formTypeId,
            { params: { fieldName: "socketFinish" } }
          )
        ).data,

        mountingPlates: (
          await apiClient.get("fieldOptions/" + this.props.formTypeId,
            {
              params: { fieldName: "mountingPlate" },
            }
          )
        ).data,

        prostheticHeightUOMs: (
          await apiClient.get("fieldOptions/" + this.props.formTypeId,
            { params: { fieldName: "prostheticHeightUOM" } }
          )
        ).data,
        prostheticHeights: (
          await apiClient.get("fieldOptions/" + this.props.formTypeId,
            { params: { fieldName: "prostheticHeight" } }
          )
        ).data,
        oneSystemOptions: (
          await apiClient.get("fieldOptions/" + this.props.formTypeId,
            { params: { fieldName: "oneSystem" } }
          )
        ).data,
        UOMs: (
          await apiClient.get("fieldOptions/" + this.props.formTypeId,
            { params: { fieldName: "UOM" } }
          )
        ).data,
      });

      this.loadShipDate();

      let config = {
        params: {
          fieldNames: [
            "socketFinish",
            "otherPRS",
            "fredsLegsDesignName",
            "mountingPlate",
            "prostheticHeightUOM",
            "prostheticHeight",
            "oneSystem",
            "pumpSerial",
            "UOM",
            "shorten",
            "extend",
            "insertMaterial",
            "itemsSentIn",
            "notes",
          ],
        },
      };

      const { data } = await apiClient.get("fieldInputs/" + this.props.formTypeId,
        config
      );
      let formState = this.state.formState;
      formState.socketFinish.value = data.find(
        (fi) => fi.fieldName === "socketFinish"
      ).fieldOptionId;
      formState.otherPRS.value = data.find(
        (fi) => fi.fieldName === "otherPRS"
      ).stringData;
      formState.fredsLegsDesignName.value = data.find(
        (fi) => fi.fieldName === "fredsLegsDesignName"
      ).stringData;

      formState.mountingPlate.value = data.find(
        (fi) => fi.fieldName === "mountingPlate"
      ).fieldOptionId;
      formState.oneSystem.value = data.find(
        (fi) => fi.fieldName === "oneSystem"
      ).fieldOptionId;
      formState.pumpSerial.value = data.find(
        (fi) => fi.fieldName === "pumpSerial"
      ).stringData;
      formState.UOM.value = data.find(
        (fi) => fi.fieldName === "UOM"
      ).fieldOptionId;

      formState.itemsSentIn.value = data.find(
        (fi) => fi.fieldName === "itemsSentIn"
      ).stringData;

      formState.notes.value = data.find(
        (fi) => fi.fieldName === "notes"
      ).stringData;

      formState.prostheticHeightUOM.value =
        data.find((fi) => fi.fieldName === "prostheticHeightUOM")
          .fieldOptionId ?? this.uomMetric;
      formState.prostheticHeight.value = data.find(
        (fi) => fi.fieldName === "prostheticHeight"
      ).fieldOptionId;

      if (this.isShortenSelected()) {
        formState.amount.value = data.find(
          (fi) => fi.fieldName === "shorten"
        ).numericData;
      } else if (this.isExtendSelected()) {
        formState.amount.value = data.find(
          (fi) => fi.fieldName === "extend"
        ).numericData;
      }

      for (let i = 0; i < this.state.insertMaterials.length; i++) {
        let fieldOptionId = this.state.insertMaterials[i].id;
        let fieldInput = data.find(
          (fi) =>
            fi.fieldName === "insertMaterial" &&
            fi.fieldOptionId === fieldOptionId
        );

        if (fieldInput !== undefined) {
          formState.insertMaterial.value[fieldOptionId] =
            fieldInput.booleanData;
        } else {
          formState.insertMaterial.value[fieldOptionId] = false;
        }
      }

      formState.otherPRS.isRequired = this.isOtherPRSSelected();
      formState.fredsLegsDesignName.isRequired =
        this.isLaminatingSleeveSelected();
      this.setState({ formState: formState });

      this.loadCart();
    } catch (error) {
      // this.props.handleError(new LoadFailureResult());
    }
    this.setState({ isLoaded: true });
  }

  getFieldInputPromise() {
    let data = [];

    data.push({
      fieldName: "socketFinish",
      fieldOptionId: this.state.formState.socketFinish.value,
    });

    data.push({
      fieldName: "otherPRS",
      stringData: this.isOtherPRSSelected()
        ? this.state.formState.otherPRS.value
        : null,
    });

    data.push({
      fieldName: "fredsLegsDesignName",
      stringData: this.isLaminatingSleeveSelected()
        ? this.state.formState.fredsLegsDesignName.value
        : null,
    });

    data.push({
      fieldName: "mountingPlate",
      fieldOptionId: this.state.formState.mountingPlate.value,
    });

    data.push({
      fieldName: "prostheticHeight",
      fieldOptionId: this.state.formState.prostheticHeight.value,
    });

    data.push({
      fieldName: "shorten",
      numericData: this.isShortenSelected()
        ? this.state.formState.amount.value
        : null,
    });

    data.push({
      fieldName: "extend",
      numericData: this.isExtendSelected()
        ? this.state.formState.amount.value
        : null,
    });

    data.push({
      fieldName: "itemsSentIn",
      stringData: this.state.formState.itemsSentIn.value,
    });

    data.push({
      fieldName: "notes",
      stringData: this.state.formState.notes.value,
    });

    data.push({
      fieldName: "pumpSerial",
      stringData: this.state.formState.pumpSerial.value,
    });
    
    data.push({
      fieldName: "UOM",
      fieldOptionId: this.state.formState.UOM.value,
    });

    data.push({
      fieldName: "oneSystem",
      fieldOptionId: this.state.formState.oneSystem.value,
    });

    this.saveMeasureData();

    for (let i = 0; i < this.state.insertMaterials?.length; i++) {
      let fieldOptionId = this.state.insertMaterials[i].id;

      data.push({
        fieldName: "insertMaterial",
        fieldOptionId: fieldOptionId,
        booleanData: this.state.formState.insertMaterial.value[fieldOptionId],
      });
    }
    return apiClient.post("fieldInputs/" + this.props.formTypeId,
      data
    )
    }
  
    saveData() {

    if (this.validateData().isValid) {
      this.getFieldInputPromise();
    } else {
      this.setState({
        isSubmit: true,
      });
      CreateNotification(this.validateData().errorMessage, "error");

      return null;
    }
  }

  async loadMeasureData() {
    try {
      this.setState({
        UOMs: (
          await apiClient.get("fieldOptions/" + this.props.formTypeId,
            { params: { fieldName: "UOM" } }
          )
        ).data,
      });

      let config = {
        params: {
          fieldNames: [
            "UOM",
            "MPTToFloor",
            "CalfToFloor",
            "CalfCirc",
            "AnkleCirc",
          ],
        },
      };

      const { data } = await apiClient.get("fieldInputs/" + this.props.formTypeId,
        config
      );
      let formState = this.state.formState;
      formState.UOM.value = data.find(
        (fi) => fi.fieldName === "UOM"
      ).fieldOptionId;
      formState.MPTToFloor.value =
        data.find((fi) => fi.fieldName === "MPTToFloor").numericData ?? "";
      formState.CalfToFloor.value =
        data.find((fi) => fi.fieldName === "CalfToFloor").numericData ?? "";
      formState.CalfCirc.value =
        data.find((fi) => fi.fieldName === "CalfCirc").numericData ?? "";
      formState.AnkleCirc.value =
        data.find((fi) => fi.fieldName === "AnkleCirc").numericData ?? "";

      this.setState({ formState: formState });
    } catch (error) {
      // this.props.handleError(new LoadFailureResult());
    }

    // this.setState({ isLoaded: true });
  }

  saveMeasureData() {

    let data = [];

    data.push({
      fieldName: "UOM",
      fieldOptionId: this.state.formState.UOM.value,
    });

    data.push({
      fieldName: "MPTToFloor",
      numericData: this.state.formState.MPTToFloor.value,
    });

    data.push({
      fieldName: "CalfToFloor",
      numericData: this.state.formState.CalfToFloor.value,
    });

    data.push({
      fieldName: "CalfCirc",
      numericData: this.state.formState.CalfCirc.value,
    });

    data.push({
      fieldName: "AnkleCirc",
      numericData: this.state.formState.AnkleCirc.value,
    });

    return apiClient.post("fieldInputs/" + this.props.formTypeId,
      data
    );
  }

  handleAmountUnit = (e) => {
    this.setState({ unit: e.target.value });
    this.props.setActiveInnerStep(7);
  };

  formatShipDate(shipDate) {
    if (!shipDate) {
      return "";
    }
    return `${shipDate.month}/${shipDate.day}/${shipDate.year}`;
  }

  handleAmountChange(e, value) {
    let formState = this.state.formState;
    formState.amount.value = e;
    this.setState({ formState: formState, hasDataChanged: true });
  }

  handleError(id) {
    const { formState } = this.state;
    const errorClass =
      formState[id].isRequired &&
      (formState[id].value === "" ||
        formState[id].value === 0 ||
        formState[id].value === null);
    return errorClass ? true : false;
  }

  convertToISOString(dateString) {
    const dateParts = dateString.split("-");
    const convertedDate = new Date(
      dateParts[0],
      dateParts[1] - 1,
      dateParts[2]
    );

    return convertedDate;
  }
  formatDateToString(date) {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");

    return `${year}-${month}-${day}`;
  }

  render() {
    if (!this.state.isLoaded) return this.makeLoadingText();

    return (
      <div className="ttOneMeasure">
        <div className="checkFormWrapper">
          <FormTitle
            title="Socket Design Specifications"
            description=""
          />

          <form className="checkform" onSubmit={e => {e.preventDefault()}}>
            <div className="">
              <div className="ttDefinitive">
                <div className="unitWrapper">
                  <MuiRadio
                    options={this.state.UOMs}
                    defaultValue={this.state.formState.UOM.value}
                    label="Unit of Measurement"
                    error={this.handleError("UOM") && this.state.isSubmit}
                    required={this.state.formState["UOM"].isRequired}
                    onChange={(e) => {
                      this.onRadioChange(e, "UOM");
                    }}
                  />
                  <div className="measureImg">
                    <img
                      src={ttDefBodypart}
                      alt="measure"
                      width="295"
                      height="310px"
                    />

                    <div className="inputs">
                      <div className="floor">
                        <InputTextField
                          // variant="outlined"
                          placeholder=""
                          type="text"
                          value={this.state.formState.MPTToFloor.value}
                          error={
                            this.handleError("MPTToFloor") &&
                            this.state.isSubmit
                          }
                          onChange={(e) => {
                            this.onInputChange(e, "MPTToFloor");
                          }}
                        />
                      </div>

                      <div className="calf">
                        <InputTextField
                          // variant="outlined"
                          placeholder=""
                          type="text"
                          value={this.state.formState.CalfToFloor.value}
                          error={
                            this.handleError("CalfToFloor") &&
                            this.state.isSubmit
                          }
                          onChange={(e) => this.onInputChange(e, "CalfToFloor")}
                        />
                      </div>

                      <div className="largestCalf">
                        <InputTextField
                          // variant="outlined"
                          placeholder=""
                          type="text"
                          value={this.state.formState.CalfCirc.value}
                          error={
                            this.handleError("CalfCirc") && this.state.isSubmit
                          }
                          onChange={(e) => this.onInputChange(e, "CalfCirc")}
                        />
                      </div>

                      <div className="largestAnkle">
                        <InputTextField
                          // variant="outlined"
                          placeholder=""
                          type="text"
                          width="60px"
                          value={this.state.formState.AnkleCirc.value}
                          error={
                            this.handleError("AnkleCirc") && this.state.isSubmit
                          }
                          onChange={(e) => this.onInputChange(e, "AnkleCirc")}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="fieldBorder filedWidth">
              <MuiRadio
                options={this.state.oneSystemOptions}
                defaultValue={this.state.formState.oneSystem.value}
                label="One® System"
                error={this.handleError("oneSystem") && this.state.isSubmit}
                required={this.state.formState["oneSystem"].isRequired}
                onChange={(e) => {
                  this.props.setActiveInnerStep(2);
                  this.onRadioChange(e, "oneSystem");
                }}
              />
              <div style={{ marginTop: "24px" }}>
                <InputTextField
                  label="Pump Serial Number"
                  variant="outlined"
                  placeholder="Serial Number"
                  type="text"
                  width="384px"
                  value={this.state.formState.pumpSerial.value}
                  error={this.handleError("pumpSerial") && this.state.isSubmit}
                  required={this.state.formState["pumpSerial"].isRequired}
                  onChange={(e) => {
                    this.onInputChange(e, "pumpSerial");
                  }}
                />
              </div>
            </div>

            <div className="fieldBorder">
              <h4 className="headLable">Socket Finish</h4>
              <div className="radioGroup">
                <FormControl>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    value={this.state.formState.socketFinish.value}
                    defaultValue={this.state.formState.socketFinish.value}
                    onChange={(e) => {
                      const newValue = e.target.value;
                      this.setState({
                        selectedValue: newValue,
                      });
                      this.props.setActiveInnerStep(3);
                      this.onRadioChange(e, "socketFinish");
                    }}
                    name="radio-buttons-group"
                    row
                  >
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <FormLabel id="demo-radio-buttons-group-label">
                        Default
                      </FormLabel>
                      {[this.state.socketFinishes[0]].map((name) => (
                        <FormControlLabel
                          value={name.id}
                          control={<Radio />}
                          label={
                            <div className="radioLabel">
                              <div className="radioIcon">
                                <span>{name.displayName}</span>
                              </div>

                              <span>{name.partNumbers}</span>
                            </div>
                          }
                          className={`${
                            parseInt(this.selectedValue) === name.id
                              ? "checkedLabel"
                              : this.state.formState.socketFinish.value ===
                                name.id
                              ? "checkedLabel"
                              : ""
                          }`}
                        />
                      ))}
                    </div>

                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <FormLabel id="demo-radio-buttons-group-label">
                        Skin Tone
                      </FormLabel>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          flexWrap: "wrap",
                          gap: "16px",
                        }}
                      >
                        {this.state.socketFinishes
                          .filter((finish) =>
                            this.isPRSOption(finish.displayName)
                          )
                          .map((name) => (
                            <FormControlLabel
                              value={name.id}
                              control={<Radio />}
                              label={
                                <div
                                  className="radioLabel"
                                  // style={{ display: "flex" }}
                                >
                                  <div className="radioIcon">
                                    <span>{name.displayName}</span>
                                  </div>

                                  <span>{name.partNumbers}</span>
                                </div>
                              }
                              className={`${
                                parseInt(this.selectedValue) === name.id
                                  ? "checkedLabel"
                                  : this.state.formState.socketFinish.value ===
                                    name.id
                                  ? "checkedLabel"
                                  : ""
                              }`}
                            />
                          ))}
                      </div>
                    </div>

                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <FormLabel id="demo-radio-buttons-group-label">
                        Decorative Lamination
                      </FormLabel>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          flexWrap: "wrap",
                          gap: "16px",
                        }}
                      >
                        {this.state.socketFinishes
                          .filter(
                            (finish) => !this.isPRSOption(finish.displayName)
                          )
                          .slice(1)
                          .map((name) => (
                            <FormControlLabel
                              value={name.id}
                              control={<Radio />}
                              label={
                                <div className="radioLabel">
                                  <div className="radioIcon">
                                    <span>{name.displayName}</span>
                                  </div>

                                  <span>{name.partNumbers}</span>
                                </div>
                              }
                              className={`${
                                parseInt(this.selectedValue) === name.id
                                  ? "checkedLabel"
                                  : this.state.formState.socketFinish.value ===
                                    name.id
                                  ? "checkedLabel"
                                  : ""
                              }`}
                            />
                          ))}
                      </div>
                    </div>
                  </RadioGroup>
                </FormControl>
              </div>
            </div>

            <div className="fieldBorder">
              <MuiRadio
                options={this.state.mountingPlates}
                defaultValue={this.state.formState.mountingPlate.value}
                label="Mounting Plate"
                error={this.handleError("mountingPlate") && this.state.isSubmit}
                required={this.state.formState["mountingPlate"].isRequired}
                onChange={(e) => {
                  this.props.setActiveInnerStep(4);
                  this.onRadioChange(e, "mountingPlate");
                }}
              />
            </div>

            <div className="fieldBorder">
              <MuiRadio
                options={this.state.prostheticHeights}
                label="Prosthetic Height Adjustment"
                defaultValue={this.state.formState.prostheticHeight.value}
                error={
                  this.handleError("prostheticHeight") && this.state.isSubmit
                }
                required={this.state.formState["prostheticHeight"].isRequired}
                onChange={(e) => {
                  this.props.setActiveInnerStep(5);
                  this.onRadioChange(e, "prostheticHeight");
                }}
              />
              {this.showAmount()}
            </div>

            <div className="msgBox fieldBorder msgBoxWidth">
              <div className="possibelDate">
                <div><h4 className="headLable"><b>Earliest Ship Date</b>: {this.formatShipDate(this.state.estimatedShipDate)}</h4>
              </div>
              </div>
              <InputTextField
                label="Items sent with Order"
                variant="outlined"
                placeholder="Type Something here..."
                type="text"
                multiline
                rows={6}
                value={this.state.formState.itemsSentIn.value}
                error={this.handleError("itemsSentIn") && this.state.isSubmit}
                required={this.state.formState["itemsSentIn"].isRequired}
                onChange={(e) => {
                  this.onInputChange(e, "itemsSentIn");
                  this.props.setActiveInnerStep(6);
                }}
              />
            </div>

            <div className="msgBox msgBoxWidth">
              <h4 className="headLable"> Notes</h4>
              <InputTextField
                label="Other Notes"
                variant="outlined"
                placeholder="Type Something here..."
                type="text"
                multiline
                rows={6}
                value={this.state.formState.notes.value}
                error={this.handleError("notes") && this.state.isSubmit}
                onChange={(e) => {
                  this.onInputChange(e, "notes");
                  this.props.setActiveInnerStep(9);
                }}
              />
            </div>
          </form>
        </div>
        <div className="handelButtons">
          <SecondaryButton
            text="Save As Draft"
            onClick={this.props.handleClickOpen}
          />
          <div className="stepBtn">
            <SecondaryButton
              text="Back"
              onClick={() => this.props.handleBack(this.props.currentIndex - 1)}
            />
            <Button
              text="Next"
              onClick={async () => {
                try {
                  this.setState({ isLoading: true });
                  const res = await this.saveData();
                  if (res.status === 204) {
                    this.props.handleNext(this.props.currentIndex);
                    this.setState({ isLoading: false });
                    CreateNotification("Submitted", "success");
                  }
                } catch (err) {
                  console.log(err);
                  this.setState({ isLoading: false });
                }
              }}
            />
          </div>
        </div>
        <SaveAsDraft
          open={this.props.open}
          handleClose={this.props.handleClose}
          showSubmit={this.props.showSubmit}
          setShowSubmit={this.props.setShowSubmit}
        />
      </div>
    );
  }

  //   showOtherPRS() {
  //     if (this.isOtherPRSSelected()) {
  //         return (
  //             <Form.Group controlId="otherPRS">
  //                 <Form.Label>Other PRS #</Form.Label>
  //                 {this.makeFormControl()}
  //             </Form.Group>
  //         );
  //     }
  // }

  // showFredsLegsDesign() {
  //     if (this.isLaminatingSleeveSelected()) {
  //         return (
  //             <Form.Group controlId="fredsLegsDesignName">
  //                 <Form.Label>Freds Legs Design Name</Form.Label>
  //                 {this.makeFormControl()}
  //             </Form.Group>
  //         );
  //     }
  // }

  isPRSOption(option) {
    return option.includes("PRS");
  }

  isOtherPRSSelected() {
    return this.state.formState.socketFinish.value === this.otherPRS;
  }

  isLaminatingSleeveSelected() {
    return this.state.formState.socketFinish.value === this.laminatingSleeve;
  }

  showAmount() {
    if (this.isShortenSelected() || this.isExtendSelected()) {
      return (
        <>
          <Form.Group controlId="amount">
            <MuiRadio
              options={this.state.prostheticHeightUOMs}
              label="Unit of Measurement"
              required={true}
              defaultValue={this.state.formState.prostheticHeightUOM.value}
              onChange={(e) => {
                this.props.setActiveInnerStep(7);
                this.onRadioChange(e, "prostheticHeightUOM");
              }}
            />
          </Form.Group>
          <Form.Group controlId="amount">
            <RangeSlider
              label="Amount"
              unit={this.getAmountText()}
              min={0}
              minValue={"0mm"}
              maxValue={"300mm"}
              max={this.isMMSelected() ? 254 : 10}
              step={this.isMMSelected() ? 1 : 0.25}
              initialValue={this.state.formState.amount.value}
              onChange={this.handleAmountChange}
              valueLabelDisplay="auto"
              aria-labelledby="continuous-slider-always"
            />
          </Form.Group>
        </>
      );
    }
  }

  getAmountText() {
    if (this.isMMSelected()) {
      return " mm";
    } else {
      return " in";
    }
  }

  isMMSelected() {
    return this.state.formState.prostheticHeightUOM.value === this.uomMetric;
  }

  isShortenSelected() {
    return this.state.formState.prostheticHeight.value === this.shortenId;
  }

  isExtendSelected() {
    return this.state.formState.prostheticHeight.value === this.extendId;
  }
}

export default TTOneMeasure;